// extracted by mini-css-extract-plugin
module.exports = {"FormTitle":"FormTitle_FormTitle__3L8TH","subTitle":"FormTitle_subTitle__2UOxy"};